import { render, staticRenderFns } from "./model_42.vue?vue&type=template&id=6685fdc4&scoped=true"
import script from "./model_42.vue?vue&type=script&lang=js"
export * from "./model_42.vue?vue&type=script&lang=js"
import style0 from "./model_42.vue?vue&type=style&index=0&id=6685fdc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6685fdc4",
  null
  
)

export default component.exports